import { StateCreator } from 'zustand';
import { listMyOrgs, OrgSummary } from '../../organization/OrganizationApi';

export type OrganizationsStatus = 'idle' | 'loading' | 'ready' | 'error';
export interface OrganizationsState {
  organizations: OrgSummary[];
  organizationsStatus: OrganizationsStatus;
  activeOrganizationId: string | null;
  setActiveOrganizationId: (id: string | null) => void;
  fetchOrganizations: () => Promise<void>;
  updateOrganizationSummary: (id: string, patch: Partial<OrgSummary>) => void;
}

export const createOrganizationsStore: StateCreator<OrganizationsState> = (
  set
) => {
  let requestVersion = 0;
  return {
    organizations: [],
    organizationsStatus: 'idle',
    activeOrganizationId: null,
    setActiveOrganizationId: (id) => set({ activeOrganizationId: id }),
    updateOrganizationSummary: (id, patch) =>
      set((state) => ({
        organizations: state.organizations.map((org) =>
          org.org_id === id ? { ...org, ...patch } : org
        ),
      })),
    fetchOrganizations: async () => {
      const version = ++requestVersion;
      set({ organizationsStatus: 'loading' });
      try {
        const organizations = await listMyOrgs();
        if (version === requestVersion)
          set({ organizations, organizationsStatus: 'ready' });
      } catch {
        if (version === requestVersion) set({ organizationsStatus: 'error' });
      }
    },
  };
};
